import { TextField } from '@mui/material';
import styled from 'styled-components';

interface Props {
  value: string;
  onChange: (e: any) => void;
  hasError: boolean;
}

export const StyledTextField = styled(TextField)`
background-color: #fff;
`;

export const StripeCardholderName = ({ value, onChange, hasError }: Props) => {
  return (
    <StyledTextField
      label="Name on Credit Card"
      variant="outlined"
      size="small"
      fullWidth
      onChange={onChange}
      value={value}
      error={hasError}
      helperText={hasError ? 'Please enter the name as it appears on your Credit Card' : ''}
      data-testid="name-on-credit-card"
    />
  );
};
